module.exports = __webpack_public_path__ + "static/img/img_page_not_found.0d481014.png";